import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faHomeAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { formatAddress, IAddress } from 'utils/address';
import { formatTime } from 'utils/date-helpers';

const Pill = styled.span`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 5px;
  padding: 4px;
  margin-right: 0.5rem;
  white-space: nowrap;
`;

type Props = {
  address: IAddress;
  time?: Date;
};
const AddressAndTimePill: React.FC<Props> = ({ address, time }) => {
  const theme = useTheme();
  return (
    <Pill>
      <FontAwesomeIcon icon={faHomeAlt} color={theme.colors.foreground.tint} />{' '}
      {formatAddress(address)}{' '}
      <FontAwesomeIcon icon={faClock} color={theme.colors.foreground.tint} />{' '}
      {formatTime(time)}
    </Pill>
  );
};

export default AddressAndTimePill;
